/**
 * Created by vlad.p on 9/8/2017.
 */

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { Location } from "../../../../objects/management/locationManagement/location";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { NgForm, NgModel } from "@angular/forms";
import { CalculatorService } from "../../../../services/calculator/calculatorService";
import { ExtraDataService } from "../../../../services/extraDataService";
import { LocationUtil } from "../../../../common/utils/LocationUtil";
import { CalculatorType } from "../../../../objects/orders/calculatorType";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { ProductsCardComponent } from "../products-card/products-card.component";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { OrderItem } from "../../../../objects/orders/orderItem";
import { OrderItemOptions } from "../../../../objects/orders/orderItemOptions";
import { CalculatorAccordion } from "../../accordions/product-accordion/calculator-accordion.component";
import { CountryService } from "../../../../services/CountryService";
import { OrderLocation } from "../../../../objects/management/order/orderLocation";
import { HowQuicklyImportType } from "../../../../objects/orders/how-quickly-import-type";

@Component({
    selector: "location-card",
    templateUrl: "location-card.component.html",
    moduleId: module.id.toString()
})
export class LocationCardComponent implements OnInit {

    @Input()
    public order: Order;

    @Input()
    public productsCard: ProductsCardComponent;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Input()
    public disableChanges: boolean;

    public locationTo: OrderLocation = new OrderLocation();

    @ViewChild('shipmentForm')
    private locationForm: NgForm;

    @ViewChild('locationToModel')
    public locationToModel: NgModel;

    @ViewChild('location')
    public locationFromModel: NgModel;

    @ViewChild('location')
    public locationFrom: NgModel;

    @Output() vehicleChange: EventEmitter<boolean> = new EventEmitter();

    public locationToString: string;
    public locationFromString: string;

    public isVehicle: boolean = false;
    public calculatorHelper = CalculatorHelper;
    public orderStatus = OrderStatus;
    public orderOptions = OrderOptions;
    public howQuicklyImportTypeRef = HowQuicklyImportType;

    private locationFromId: number = null;
    private locationToId: number = null;

    public showShippingTrackOption: boolean = true;
    public showShippingAirOption: boolean = true;
    public showShippingOceanOption: boolean = true;

    public constructor(private calculatorService: CalculatorService, private ChangeDetectorRef: ChangeDetectorRef, private countryService: CountryService) {
    }

    get whoIsShipping() {
        if(this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsCommercialCarrier)){
            return 0;
        } else {
            if(this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsDrivingAcross)){
                return 1;
            }
            return 0;
        }
    }

    set whoIsShipping(val: number) {
        if (val == 0) {
            this.order.Flag &= ~OrderOptions.IsDrivingAcross;
            this.order.Flag |= OrderOptions.IsCommercialCarrier;
        } else {
            this.order.Flag &= ~OrderOptions.IsCommercialCarrier;
            this.order.Flag |= OrderOptions.IsDrivingAcross;
        }
    }

    get carryingType(){
        return this.order.CarryingType;
    }

    set carryingType(val: number){
        if (this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsOcean))
            this.order.Flag &= ~OrderOptions.IsOcean;

        if(val != 1){
            this.order.Flag &= ~OrderOptions.IsCommercialCarrier;
            this.order.Flag &= ~OrderOptions.IsDrivingAcross;
        }

        if (val == 3)
            this.order.Flag |= OrderOptions.IsOcean;

        this.order.CarryingType = val;
    }

    get howQuicklyImportType(){
        return this.order.HowQuicklyImportType;
    }

    set howQuicklyImportType(val: HowQuicklyImportType){
        this.order.HowQuicklyImportType = val;
    }

    public ngOnInit(): void {
        this.locationTo.Type = 2;

        let locTo = this.order.Locations.find(x => x.Type == 2);

        if (locTo)
            this.locationTo = locTo;

        if (!this.locationToString)
            this.locationToString = LocationUtil.formatAddress(this.locationTo, true);

        if (!this.locationFromString)
            this.locationFromString = LocationUtil.formatAddress(this.order.Customer.Location, true);

        if (this.order && this.order.Flag)
            this.isVehicle = this.order.Flag.hasFlag(OrderOptions.IsVehicle);

        if(!this.order.CarryingType){
            this.order.CarryingType = 1;
        }
    }

    public onLocationFromChange(location: OrderLocation): void {
        if (location != null) {
            this.locationFromString = LocationUtil.formatAddress(location, true);
        }

        const tempLocation =  this.order.Customer.Location;//this.order.Locations.find(x => x.Type == 1);

        if(tempLocation && tempLocation.Id != null && typeof tempLocation.Id !='undefined'
            && this.order.Id != null && typeof this.order.Id !='undefined'){
            this.locationFromId = tempLocation.Id; // store id of previous location
        }

        this.order.Customer.Location = location;


        if (this.locationFromId != null && this.order.Customer.Location)
            this.order.Customer.Location.Id = this.locationFromId;

        if (this.order.Customer.Location) {
            this.order.Customer.Location.Type = 1;
            //CalculatorHelper.setDefaultCurrency(this.canadianCurrencyCodes, this.order, this.productsCard.calculatorAccordion.toArray(), this.countryService, false);
        }

        if (CalculatorHelper.isCanadianVehicleCalculator(this.order) && !CalculatorHelper.isUsaShipmentFrom(this.order)) {
            this.clearVehicleParts();
        }

        this.ChangeDetectorRef.detectChanges();
        this.locationFromModel.model.control.updateValueAndValidity();
        this.ChangeDetectorRef.detectChanges(); // Some serious shit happens with this validation

        this.calculatorService.broadcast(this.order.Customer.Location);
        
        this.showCarryingTypes(this.order);
    }

    public onCarryingTypeChange(val: number): void{
        if(val != 1){
            this.order.Flag &= ~OrderOptions.IsCommercialCarrier;
            this.order.Flag &= ~OrderOptions.IsDrivingAcross;
            console.log(this.order.Flag);
        }
    }

    public onLocationToChange(location: OrderLocation): void {
        this.locationTo = location;

        if (location != null)
            this.locationToString = LocationUtil.formatAddress(location, true);

        this.ChangeDetectorRef.detectChanges();
        this.locationToModel.model.control.updateValueAndValidity();
        this.ChangeDetectorRef.detectChanges(); // Some serious shit happens with this validation

        if (!location) {
            this.order.CalculatorType = null;

            if (!this.order.Id) {
                this.order.Locations = new Array<OrderLocation>();
                return;
            }

            let tempLocation = this.order.Locations.find(x => x.Type == 2); //todo mb store id in local variable)
            tempLocation.Country = '';
            tempLocation.City = '';
            tempLocation.Zip = '';
            tempLocation.State = '';
            tempLocation.Street = '';
            return;
        }

        if (location instanceof Location) {
            this.clearVehicleFlags();

            const tempLocation = this.order.Locations.find(x => x.Type == 2);

            this.order.Locations = new Array<OrderLocation>();

            if (tempLocation && tempLocation.Id != null && typeof tempLocation.Id != 'undefined')
                this.locationTo.Id = tempLocation.Id;

            this.order.Locations.push(this.locationTo);

            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            this.calculatorService.broadcast(location);
        }

        if (String.isNullOrEmpty(location.toString())) {
            this.order.Locations = [];
            this.calculatorService.broadcast(null);
        }
        this.showCarryingTypes(this.order);
    }

    public showCarryingTypes( order: Order): void {

        if(order.Customer.Location != null && order.Locations.length){
            const shipToLoc = order.Locations.find(x => x.Type == 2);
            const shipFromLoc = order.Customer.Location.Country;

            if(shipFromLoc == "United States" && shipToLoc.Country == "Canada"){
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = false;
                this.showShippingOceanOption = false;
            }else if(shipFromLoc == "Canada" && shipToLoc.Country == "United States"){
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }else if(shipToLoc.Country == "United States") {
                this.carryingType = 1;
                this.showShippingTrackOption = true;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }else if(shipFromLoc != "Canada"){
                this.carryingType = 2;
                this.showShippingTrackOption = false;
                this.showShippingAirOption = true;
                this.showShippingOceanOption = true;
            }

        }else {
            this.carryingType = 1;
            this.showShippingTrackOption = true;
            this.showShippingAirOption = true;
            this.showShippingOceanOption = true;
        }
    }

    public setLocationTo(location: OrderLocation): void {
        this.locationToString = LocationUtil.formatAddress(location, true);

        if (location)
            this.locationTo = location;

        this.locationTo.Type = 2;

        if (location != null && location.Country != null) {
            this.order.Locations = new Array<OrderLocation>();
            this.order.Locations.push(this.locationTo);

            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            this.calculatorService.broadcast(location);
        }

        if (String.isNullOrEmpty(location.toString())) {
            this.order.Locations = [];
            this.calculatorService.broadcast(null);
        }
    }

    public setLocationFrom(location: OrderLocation): void {
        this.locationFromString = LocationUtil.formatAddress(location, true);
        this.calculatorService.broadcast(location);
    }

    public setVehicle(value: boolean): void {
        if (this.disableChanges)
            return;

        this.isVehicle = value;

        this.vehicleChange.emit(value);


        if (value)
            this.order.Flag |= OrderOptions.IsVehicle;
        else
            this.order.Flag &= ~OrderOptions.IsVehicle;

        this.calculatorService.broadcastIsVeh(value);

        if (!CalculatorHelper.isCanadianVehicleCalculator(this.order)) {
            this.clearVehicleFlags();
        }
    }

    public checkForm(): boolean {
        this.locationForm.onSubmit(null);
        return this.isValid();
    }

    public isValid(): boolean {
        return this.locationFromModel.model.control.valid && this.locationToModel.model.control.valid;
    }

    public resetForm(): void {
        this.locationForm.resetForm();

        this.locationTo = new OrderLocation();

        this.locationToString = "";

        this.locationFromString = "";

        this.locationFromModel.model.control.markAsPristine();
    }

    private clearVehicleFlags(): void {
        for (let productCard of this.productsCard.calculatorAccordion.toArray()) {
            if (productCard.orderItem.Flags == null)
                return;

            if (productCard.orderItem.Flags.hasFlag(OrderItemOptions.IsAC)) {
                productCard.orderItem.Flags &= ~OrderItemOptions.IsAC;
                productCard.isAC = false;
            }

            if (productCard.orderItem.Flags.hasFlag(OrderItemOptions.IsVehicleParts)) {
                productCard.orderItem.Flags &= ~OrderItemOptions.IsVehicleParts;
                productCard.isVehicleParts = false;
            }
        }
    }

    private clearVehicleParts(): void {
        for (let productCard of this.productsCard.calculatorAccordion.toArray()) {
            if (productCard.orderItem.Flags == null)
                return;

            if (productCard.orderItem.Flags.hasFlag(OrderItemOptions.IsVehicleParts)) {
                productCard.orderItem.Flags &= ~OrderItemOptions.IsVehicleParts;
                productCard.isVehicleParts = false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/cards/location-card/location-card.component.ts